import { createInjection } from '@/lib/createInjection';
import { onBeforeUnmount } from '@vue/composition-api';

type LogoutCleanupHandler = () => Promise<void> | void;
type LogoutCleanupContainer = { handlers: Set<LogoutCleanupHandler> };

const { provide, inject } = createInjection<LogoutCleanupContainer>('johaisetsuSagyou/logoutCleanup');

// 親画面側: 後片付け登録の受け皿を用意し、ログアウト時にアクティブな子(複数可)の
// 後片付け処理をまとめて呼び出す関数を返す
export function provideLogoutCleanup(): () => Promise<void> {
  const container: LogoutCleanupContainer = { handlers: new Set() };
  provide(container);
  return async() => {
    await Promise.all([...container.handlers].map(handler => handler()));
  };
}

// 子コンポーネント側: 自身の後片付け処理(stopAll 等)を登録する。
// アンマウント時(作業種別切替・画面遷移)は自動で解除し、他画面から誤って呼ばれないようにする
export function useLogoutCleanup(handler: LogoutCleanupHandler): void {
  const container = inject();
  container.handlers.add(handler);
  onBeforeUnmount(() => {
    container.handlers.delete(handler);
  });
}
